import React from 'react';
import { ResourceAllocationChart } from '../ResourceAllocationChart';
import { CatalogTaskMonitoring } from '../CatalogTaskMonitoring';

interface CatalogTask {
  Number: string;
  Priority: string;
  State: string;
  "Assigned to": string;
  "Short description": string;
  Opened: string;
  Duration: number;
  Impact: string;
  "Task type": string;
  "Due date": string;
  Service?: string;
  "Opened by": string;
}

interface TaskOriginTableProps {
  catalogTasks: CatalogTask[];
}


interface CatalogTasksSectionProps {
  incidents: any[];
  catalogTasks: CatalogTask[];
}

export function CatalogTasksSection({ incidents, catalogTasks }: CatalogTasksSectionProps) {
  return (
    <>
      <h2 className="text-2xl font-bold mb-6">Catalog Task Monitoring</h2>
      <p className="text-muted-foreground mb-6">
        Comprehensive view of all catalog tasks with advanced filtering.
      </p>
      <div className="space-y-6">
        <ResourceAllocationChart 
          incidents={incidents} 
          catalogTasks={catalogTasks} 
        />

        <CatalogTaskMonitoring catalogTasks={catalogTasks} showFullDetails />
        
      </div>
    </>
  );
}
